import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-1 flex items-stretch overflow-hidden" }
const _hoisted_2 = { class: "flex-1 overflow-y-auto" }
const _hoisted_3 = { class: "pr-2" }
const _hoisted_4 = {
  class: "flex justify-center items-center pt-2 pb-2",
  style: {"min-height":"56px"}
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["value", "disabled", "max"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-4 xl:gap-x-8" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "image group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-50 overflow-hidden" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-2 block h-xs font-medium text-gray-900 rounded-xs w-10" }, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-4 xl:gap-x-8 pb-8" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["id"]
const _hoisted_17 = ["href", "data-pswp-width", "data-pswp-height"]
const _hoisted_18 = { class: "group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 overflow-hidden" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "mt-2 block text-xs font-medium text-gray-900" }
const _hoisted_21 = {
  key: 0,
  class: "flex items-center justify-end"
}
const _hoisted_22 = { class: "col-span-4 lg:col-span-2" }
const _hoisted_23 = { class: "space-y-4 divide-y divide-gray-200" }
const _hoisted_24 = { class: "text-md 2xl:text-lg leading-6 font-medium text-gray-900" }
const _hoisted_25 = { class: "mt-1 pt-4" }
const _hoisted_26 = { class: "flex sm:pt-5" }

import {
  ChevronLeftIcon,
  ChevronRightIcon,
  EllipsisVerticalIcon,
  ArrowDownTrayIcon,
} from "@heroicons/vue/24/solid";
import { useCurrentCustomerName, useCurrentSiteId } from "@oculai/planner";
import axios from "axios";
import { format, isValid, parseISO } from "date-fns";
import mobile from "is-mobile";
import { Padding } from "photoswipe";
import "photoswipe/dist/photoswipe.css";
import { PhotoSwipe } from "photoswipe/dist/types/ui/ui-element";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import { Form } from "vee-validate";
import { computed, onMounted, onUnmounted, Ref, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import * as yup from "yup";
import DateField from "@/components/forms/DateField.vue";
import LoadingSpinner from "@/components/loading_state/LoadingSpinner.vue";
import BasicMenu from "@/components/other/BasicMenu.vue";
import MainButton from "@/components/other/MainButton.vue";
import { useCustomToast } from "@/composables/toast";
import CameraRepository from "@/repositories/CameraRepository";
import logger from "@/services/logger";
import { GalleryImagesPaginatedResponse } from "@/types/Camera";
import CameraItemLayout from "@/views/camera/components/CameraItemLayout.vue";
import GalleryDownload from "@/views/camera/components/GalleryDownload.vue";
import WeatherContainer from "@/views/camera/components/WeatherContainer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GalleryContent',
  props: {
  isPublic: {
    type: Boolean,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const isMobileDevice = ref<boolean>(mobile());
const hasFilePicker = !!window.showSaveFilePicker;

const lightbox = ref(null) as Ref<PhotoSwipeLightbox | null>;
const data = ref(null) as Ref<null | GalleryImagesPaginatedResponse>;
const date = ref(null) as Ref<Date | null>;
const searchDate = ref(null) as Ref<null | string>;
const loading = ref(false) as Ref<boolean>;
const buttonLoad = ref(false) as Ref<boolean>;
const showDefaultImages = ref(false) as Ref<boolean>;
const showHeaderDatePicker = ref(false) as Ref<boolean>;
const galleryDownloadModalOpen = ref(false) as Ref<boolean>;
const route = useRoute();
const { t } = useI18n();
const customer = useCurrentCustomerName();
const site = useCurrentSiteId();
const noData = ref(true) as Ref<boolean>;
const toast = useCustomToast();

const schema = computed(() =>
  yup.object({
    galleryDate: yup
      .date()
      .nullable()
      .required(t("err.required"))
      .max(
        maxDate.value,
        t("err.err_future_date", { maxDate: format(maxDate.value, "yyyy-MM-dd") }),
      ),
  }),
);

onMounted(() => {
  getGalleryImages(dateToString.value);
});

onUnmounted(() => {
  if (lightbox.value) {
    lightbox.value.destroy();
    lightbox.value = null;
  }
});

const default_img = computed(() => {
  return require("@/assets/imgs/default-project-thumbnail.jpg");
});
const galleryId = computed(() => {
  return `gallery-${customer}-${site}-${route.params.camera_id}`;
});
const maxDate = computed(() => {
  return new Date();
});

const dateToString = computed(() => {
  return date.value ? format(date.value, "yyyy-MM-dd") : "";
});

watch(loading, (newLoadingValue) => {
  if (!newLoadingValue) {
    buttonLoad.value = newLoadingValue;
  }
});

watch(searchDate, (newDate) => {
  getGalleryImages(newDate);
});

const mountPhotoSwipe = () => {
  if (!lightbox.value) {
    const lightboxInstance = new PhotoSwipeLightbox({
      gallery: `#${galleryId.value}`,
      children: "a",
      pswpModule: () => import("photoswipe"),
      wheelToZoom: true,
      padding: { top: 10, bottom: 10 } as Padding,
    });
    lightboxInstance.on("uiRegister", () => {
      lightboxInstance.pswp?.ui?.registerElement({
        name: "download-button",
        order: 8,
        isButton: true,
        tagName: "a",

        // SVG with outline
        html: {
          isCustomSVG: true,
          inner:
            '<path d="M20.5 14.3 17.1 18V10h-2.2v7.9l-3.4-3.6L10 16l6 6.1 6-6.1-1.5-1.6ZM23 23H9v2h14" id="pswp__icn-download"/>',
          outlineID: "pswp__icn-download",
        },

        onInit: (el: HTMLElement, pswp: PhotoSwipe) => {
          el.setAttribute("download", "");
          el.setAttribute("target", "_blank");
          el.setAttribute("rel", "noopener");

          pswp.on("change", () => {
            el.setAttribute("href", pswp.currSlide?.data.src as string);
          });
        },
      });
    });
    lightboxInstance.init();
    lightbox.value = lightboxInstance;
  }
};

const displayTime = (value: string) => {
  const date = new Date(value);
  return isValid(date) ? format(new Date(value), "HH:mm") : "";
};

const getGalleryImages = async (value: string | null | undefined) => {
  try {
    noData.value = false;

    date.value = value ? parseISO(value) : null;
    loading.value = true;

    const { customer_name, site_id, camera_id } = route.params;

    data.value = props.isPublic
      ? await CameraRepository.getPublicPaginatedGalleryImages(
          customer_name as string,
          site_id as string,
          camera_id as string,
          value || (route.query.date as string) || null,
          route.params.token as string,
        )
      : await CameraRepository.getPaginatedGalleryImages(
          customer_name as string,
          site_id as string,
          camera_id as string,
          value || (route.query.date as string) || null,
        );
    date.value = new Date(data.value.date);
    showDefaultImages.value = false;

    data.value.items.forEach((img) => {
      const imgElement = new Image();
      imgElement.src = img.url;
      imgElement.addEventListener("load", () => {
        img.width = imgElement.naturalWidth;
        img.height = imgElement.naturalHeight;
      });
    });

    loading.value = false;
    if (buttonLoad.value) buttonLoad.value = false;
    mountPhotoSwipe();
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error?.response?.status !== 404) {
        logger.error(error);
      }
      data.value = null;
      if (error?.response?.data?.code === "NO_DATA_YET") {
        noData.value = true;
      } else {
        toast.error(t("err.no_data_found"));
      }
      showDefaultImages.value = true;
      loading.value = false;
      if (buttonLoad.value) buttonLoad.value = false;
      loading.value = false;
    }
  } finally {
    loading.value = false;
    if (buttonLoad.value) buttonLoad.value = false;
  }
};

const handleHeaderDatePickerChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  showHeaderDatePicker.value = false;
  getGalleryImages(target.value);
};

const formatDate = (dateValue: string | Date) => {
  const dateObject = typeof dateValue === "string" ? new Date(dateValue) : dateValue;
  return format(dateObject, "dd.MM.yyyy");
};

const onSubmit = async (values: Record<string, number | Date>) => {
  const formattedValue = format(values.galleryDate, "yyyy-MM-dd");
  await getGalleryImages(formattedValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CameraItemLayout, {
      onlyLeft: __props.isPublic,
      noData: noData.value && !loading.value
    }, {
      contentLeft: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("main", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (!loading.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (getGalleryImages(data.value?.previous))),
                      type: "button",
                      disabled: !(data.value && data.value.previous),
                      class: "border-transparent inline-flex items-center px-4 py-2 text-sm font-medium"
                    }, [
                      _createVNode(_unref(ChevronLeftIcon), {
                        class: _normalizeClass(["h-6 w-6 text-oaiGray-300", { 'text-transparent': !(data.value && data.value.previous) }]),
                        "aria-hidden": "true"
                      }, null, 8, ["class"])
                    ], 8, _hoisted_5))
                  : _createCommentVNode("", true),
                (date.value && !showHeaderDatePicker.value)
                  ? (_openBlock(), _createElementBlock("h2", {
                      key: 1,
                      class: _normalizeClass(["pl-8 pr-8 2xl:pl-12 2xl:pr-12 text-sm 2xl:text-lg font-extrabold text-oaiGray-300", __props.isPublic ? ['cursor-pointer'] : []]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (showHeaderDatePicker.value = !!__props.isPublic))
                    }, _toDisplayString(formatDate(date.value)), 3))
                  : _createCommentVNode("", true),
                (showHeaderDatePicker.value)
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 2,
                      type: "date",
                      value: date.value,
                      onChange: handleHeaderDatePickerChange,
                      disabled: loading.value,
                      max: formatDate(maxDate.value),
                      onKeydown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                      class: "oai-inputs",
                      style: {"width":"min-content !important"}
                    }, null, 40, _hoisted_6))
                  : _createCommentVNode("", true),
                (!loading.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (getGalleryImages(data.value?.next))),
                      type: "button",
                      disabled: !(data.value && data.value.next),
                      class: "border-transparent inline-flex items-center px-4 py-2 text-sm font-medium"
                    }, [
                      _createVNode(_unref(ChevronRightIcon), {
                        class: _normalizeClass(["h-6 w-6 text-oaiGray-300", { 'text-transparent': !(data.value && data.value.next) }]),
                        "aria-hidden": "true"
                      }, null, 8, ["class"])
                    ], 8, _hoisted_7))
                  : _createCommentVNode("", true)
              ]),
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                        return _createElementVNode("div", {
                          class: "loadingCard is-loading",
                          key: i
                        }, _hoisted_12)
                      }), 64))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!loading.value && showDefaultImages.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                        return _createElementVNode("div", { key: i }, [
                          _createElementVNode("img", {
                            src: default_img.value,
                            alt: "default image",
                            class: "group block w-full rounded-lg bg-gray-50 overflow-hidden"
                          }, null, 8, _hoisted_15)
                        ])
                      }), 64))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", {
                id: galleryId.value,
                class: "grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-4 xl:gap-x-8"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value?.items, (image, key) => {
                  return (_openBlock(), _createElementBlock("div", { key: key }, [
                    _createElementVNode("a", {
                      href: image.url,
                      "data-pswp-width": image.width,
                      "data-pswp-height": image.height,
                      target: "_blank",
                      rel: "noreferrer"
                    }, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("img", {
                          src: image.url,
                          class: "group-hover:opacity-75 object-cover pointer-events-none",
                          alt: "gallery image"
                        }, null, 8, _hoisted_19)
                      ])
                    ], 8, _hoisted_17),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(displayTime(image.timestamp)), 1)
                  ]))
                }), 128))
              ], 8, _hoisted_16), [
                [_vShow, !loading.value && data.value]
              ])
            ])
          ])
        ])
      ]),
      contentRight: _withCtx(() => [
        (!__props.isPublic && hasFilePicker && !isMobileDevice.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(BasicMenu, { position: "left" }, {
                icon: _withCtx(() => [
                  _createVNode(_unref(EllipsisVerticalIcon), {
                    class: "h-6 w-6",
                    "aria-hidden": "true"
                  })
                ]),
                content: _withCtx(({ item }) => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item), {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (galleryDownloadModalOpen.value = true))
                  }, {
                    default: _withCtx(({ active }) => [
                      _createElementVNode("p", {
                        class: _normalizeClass([
                  active ? 'text-yellow-600' : 'text-gray-700',
                  'px-4 py-2 cursor-pointer whitespace-nowrap flex items-center',
                ])
                      }, [
                        _createVNode(_unref(ArrowDownTrayIcon), {
                          class: "h-5 w-5 mr-2",
                          "aria-hidden": "true"
                        }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("camera.gallery.download.menu_title")), 1)
                      ], 2)
                    ]),
                    _: 2
                  }, 1024))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t("camera.gallery.pick_a_date")), 1),
            _createVNode(_unref(Form), {
              onSubmit: onSubmit,
              validationSchema: schema.value,
              class: "space-y-3 sm:space-y-5 py-3 sm:py-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(DateField, {
                    name: "galleryDate",
                    label: _ctx.$t('camera.period.date'),
                    maxDate: maxDate.value,
                    inlineField: true,
                    date: date.value
                  }, null, 8, ["label", "maxDate", "date"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(MainButton, {
                    label: _ctx.$t('camera.gallery.search'),
                    type: "submit",
                    color: "yellow",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (buttonLoad.value = true)),
                    class: "mx-0 sm:mr-0 mt-0"
                  }, {
                    default: _withCtx(() => [
                      (buttonLoad.value)
                        ? (_openBlock(), _createBlock(LoadingSpinner, {
                            key: 0,
                            size: "w-5 h-5",
                            color: "white",
                            class: "mr-2"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ]),
              _: 1
            }, 8, ["validationSchema"]),
            (data.value)
              ? (_openBlock(), _createBlock(WeatherContainer, {
                  key: 0,
                  ref: "weatherContainerComponent",
                  date: dateToString.value,
                  loadMain: loading.value
                }, null, 8, ["date", "loadMain"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onlyLeft", "noData"]),
    (galleryDownloadModalOpen.value)
      ? (_openBlock(), _createBlock(GalleryDownload, {
          key: 0,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (galleryDownloadModalOpen.value = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})